/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartNumberChangesDetailFooterComponent} from './part-number-changes-detail-footer.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [PartNumberChangesDetailFooterComponent],
    exports: [PartNumberChangesDetailFooterComponent]
})
export class PartNumberChangeDetailFooterModule {
}
